export const emptyFunction = (_data: unknown) => {};
